import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=c52c932a&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./IndexPage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=c52c932a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c932a",
  null
  
)

export default component.exports